/**************************************************
 * Nombre:        Tarjeta_Dato
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import agave from '../../Recursos/Temporales/agave.svg'
import {theme} from "../../Tema";


const Tarjeta_Dato = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.primary.main + 20,
                px: 2,
                py: 3
            }}
        >

            <Grid container size={{xs: 4, sm: 12, md: 4}} sx={{justifyContent: 'center'}}>
                <img src={item.img} width={40}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 8, sm: 12, md: 8}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 14}}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{lineHeight: 1.2, fontSize: 12}}>{item.descripcion}</Typography>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Dato